import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['box', _vm.type, 'text-left', 'd-flex', 'justify-center']},[_vm._t("default",[_c(VIcon,{staticClass:"mr-3",class:_vm.iconClass}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }